export default __webpack_public_path__ + "static/media/storeBcg.bd09ba09.jpeg";